"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
/**
 * Action called when we select discard in txp options page.  We reset the txp options in the store
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardTxpOption')(function discardTxpOption(state) {
    var optionState = state.optionState;
    optionState.CreateEventsFromEmailAsPrivate = null;
    optionState.EventsFromEmailEnabled = null;
    optionState.Events = {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    };
}));
//# sourceMappingURL=discardTxpOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/actions/discardTxpOption.js
// module id = 5267
// module chunks = 2